import Operation from "./Operation";

export default Operation;
